var render = function render(){var _vm=this,_c=_vm._self._c;return _c('zg-sticky-table-of-contents',{attrs:{"items":_vm.items,"highlighted-id":_vm.highlightedId},on:{"clickItem":_vm.scrollToItem}})
}
var staticRenderFns = []

export { render, staticRenderFns }